import React from "react";

import Banner from "./Banner";
import MainDesc from "./MainDesc";
import ProjGalBanner from "./ProjGalBanner";
import Footer from "../../general/Footer";

const Body = () => {
  return (
    <div>
      <div className="flex flex-col h-screen justify-evenly font-display text-[#39516D] pt-0">
        <div className="flex items-center pb-0">
          <div className="flex w-1/2 p-8 pb-0 space-y-4 space-x-4">
            {/* Cartier Image with Hover Text */}
            <div className="relative group w-full">
              <img
                src={"/prjimg/Cartier/cartier4.webp"}
                className="w-full object-cover"
              />

              {/* Hover overlay */}
              <div className="absolute inset-0 bg-black/40 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center">
                <a href="/cartier-@-miami-design-district">
                  <span className="text-white text-2xl font-semibold">
                    Learn about our Cartier installation here!
                  </span>
                </a>
              </div>
            </div>
          </div>

          <div className="flex-col w-1/2 space-y-2 pt-8">
            <div className="flex justify-around pt-0">
              <img
                src={"/various/50yrs.webp"}
                className="w-1/5 object-contain"
              />
              <div className="flex flex-col items-right justify-center text-4xl text-right font-semi pr-4">
                <h1>Build on our experience.</h1>
                <h1>Build with confidence.</h1>
              </div>
            </div>

            <div>
              {/* <h1 className="font-display text-center text-xl p-6 pb-0">
                Visionaries since 1973. At Massey's, our legacy speaks for
                itself. We've been the cornerstone of architectural innovation
                for over five decades.
              </h1> */}
            </div>
            <div className="flex items-center justify-center pt-4">
              <div className="flex p- items-center justify-center font-display font-bold">
                <div className="flex-col items-center p- w-full justify-around">
                  <div className="flex  text-6xl justify-center items-center whitespace-nowrap pr-8 text-center">
                    #7
                  </div>
                  <div className="flex flex-col items-center justify-center">
                    <div className="text-3xl text-center mt-5">
                      Ranked Glazier in the <br />
                      Nation by Engineering News-Record{" "}
                    </div>
                  </div>
                </div>
              </div>
              <img className="flex w-1/2 p-8"src="various/enrlogo.webp" alt="" />
            </div>
          </div>
        </div>

        <div className="flex items-center">
          <div className="flex w-1/2 h-auto p-8 space-y-4">
            <h1 className="font-display text-center text-xl p-6">
              We're not just industry leaders; we're pioneers, collaborating
              with the foremost manufacturers in glazing materials and
              cutting-edge installation techniques. Our dedication to excellence
              transcends craftsmanship; it's a commitment to shaping the future
              of architectural possibilities.
              <br />
              <br />
              We foster an inclusive environment, championing equal
              opportunities for all, irrespective of race, gender, or ability.
              At Massey's, diversity fuels our success.
              <br />
              <br />
              Rooted in a proud heritage and propelled by unwavering confidence,
              Massey's invites you to build with confidence.
            </h1>
          </div>
          <div className="flex w-1/2 p-8 space-y-4">
            <img className="flex p-4 pt-0 object-contain" src={"/various/splitscreen.webp"} />
          </div>
        </div>

        <div className="flex flex-col">
          <Banner />
          <div className="flex items-center justify-center h-1/6">
            <ProjGalBanner />
          </div>

          <Footer />
        </div>
      </div>
    </div>
  );
};

export default Body;
